// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__3np3I","layout-body":"style_layout-body__8Kxk8"};